import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const getScrollContainer = (): HTMLElement | null => {
  return document.querySelector("[data-main-content]");
};

export const ScrollToTop = () => {
  const location = useLocation();

  useEffect(() => {
    const shouldPreventAutoScroll = location.state?.preventAutoScroll;
    const hasHashFragment = location.hash;

    if (!shouldPreventAutoScroll && !hasHashFragment) {
      const timeoutId = setTimeout(() => {
        const scrollContainer = getScrollContainer();
        if (scrollContainer) {
          scrollContainer.scrollTo({ top: 0, behavior: "instant" });
        }
      }, 0);

      return () => clearTimeout(timeoutId);
    }
  }, [location.pathname, location.state, location.hash]);

  return null;
};
